import React from "react";

const PreferredTagComponent = ({ preferred }) => {
  if (preferred !== "1") return null;

  return (
    <img
      src="https://img.icons8.com/?size=100&id=eejUGEX0qHvl&format=png&color=000000"
      className="position-absolute"
      width={50}
      height={50}
      alt="Preferred Tag"
    />
  );
};

export default PreferredTagComponent;
